const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const moment = require("moment");

const LoadState = require("../../core/vault/util/LoadState");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const CreditInfo = require("../../office/checkout/CreditInfo");
const OfficeModal = require("../../office/modals/OfficeModal");
const {ChooseOptionModal} = require("../../office/modals/ChooseOptionModal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const CopyTable = require("../../office/data/CopyTable");
const LoadingCircle = require("../../core/view/LoadingCircle");

const styles = require("./styles/EditableAddressCard.css");

const checkoutErrorCopy = CopyTable.getCheckoutErrorCopy();

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "EditableCard",

		propTypes: {
			cc4: PT.string,
			expMonth: PT.oneOfType([PT.number, PT.string]),
			expYear: PT.oneOfType([PT.number, PT.string]),
			disableDelete: PT.bool,
			warningText: PT.string,
			onUpdate: PT.func,
			onDelete: PT.func,
			startOpen: PT.bool,
		},

		vaultEvents: {
			parentFormSuccess: function() {
				this.setState({
					isLoading: false,
					isModalOpen: false,
					validation: null,
					errorMessage: null,
				});
			},
			parentFormValidationFail: function(validation) {
				this.setState({
					isLoading: false,
					validation,
				});
			},
			parentFormFail: function(error, moreInfo) {
				let errorMessage = null;
				if (error === "E_NO_BILLING") {
					errorMessage = "Please enter a billing address first.";
				} else if (error === "E_CHECKOUT_INPUT") {
					errorMessage = this.getInputError(moreInfo);
				} else if (error === "E_TOO_MANY_CREDIT_CARD_UPDATES") {
					errorMessage =
						"Too many change attempts. Please email orders@beastacademy.com for help.";
				} else if (error === "E_CVV_LENGTH_MISMATCH") {
					errorMessage =
						"CVV must be 4 digits for American Express and 3 digits for other card types.";
				} else if (error === "E_ZIP_CODE_INVALID_CHAR") {
					errorMessage =
						"There was an error in your address. The postal code can only contain letters, numbers, spaces, and hyphens.";
				} else if (error === "E_CARD_TYPE_NOT_SUPPORTED") {
					errorMessage =
						"Your card type is not supported. Please try a different credit card.";
				} else if (LoadState.shouldRetry(error)) {
					errorMessage =
						"There was an issue connecting to the server. Please try again.";
				} else {
					errorMessage =
						"Your card could not be saved as entered. Please check the card number, expiration, and CVV and try again.";
				}
				this.setState({
					isLoading: false,
					errorMessage,
				});
			},
			deleteCreditCardSuccess: function() {
				this.setState({
					isLoading: false,
					isModalOpen: false,
					validation: null,
					errorMessage: null,
				});
			},
			deleteCreditCardFail: function(error) {
				let errorMessage = null;
				if (LoadState.shouldRetry(error)) {
					errorMessage =
						"There was an issue connecting to the server. Please try again.";
				} else {
					errorMessage =
						"There was an issue removing your info. Please try again.";
				}
				this.setState({
					isLoading: false,
					errorMessage,
				});
			},
		},

		getInitialState: function() {
			return {
				isModalOpen: this.props.startOpen || false,
				number: "",
				expMonth: moment().month() + 1,
				expYear: moment().year(),
				cvv: "",
				isLoading: false,
				validation: null,
				errorMessage: null,
				showConfirm: false,
			};
		},

		getInputError: function(moreInfo) {
			const badField = _.get(moreInfo, "creditCard[0]");
			if (badField === "number") {
				return (
					checkoutErrorCopy.cardInvalid || checkoutErrorCopy.billingFieldError
				);
			} else if (badField === "exp") {
				return (
					checkoutErrorCopy.cardInvalidExp ||
					checkoutErrorCopy.billingFieldError
				);
			} else {
				return checkoutErrorCopy.billingFieldError;
			}
		},

		openModal: function() {
			this.setState({
				isModalOpen: true,
				validation: null,
				errorMessage: null,
			});
		},

		closeModal: function() {
			// Need to clear fields
			this.setState(_.extend(this.getInitialState(), {isModalOpen: false}));
		},

		updateField: function(field, val) {
			this.setState({[field]: val});
		},

		update: function() {
			this.setState({
				isLoading: true,
				validation: null,
			});
			this.props.onUpdate(
				_.pick(this.state, ["number", "cvv", "expMonth", "expYear"])
			);
		},

		getKeyHandler: function(f) {
			return evt => {
				if (evt.which === 13) {
					f();
				}
			};
		},

		confirmDelete: function() {
			this.setState({showConfirm: true});
		},

		closeConfirm: function() {
			this.setState({showConfirm: false});
		},

		deleteCard: function() {
			this.props.onDelete();
			this.setState({
				isLoading: true,
				showConfirm: false,
			});
		},

		render: function() {
			const {cc4, disableDelete, warningText} = this.props;
			const {
				number,
				expMonth,
				expYear,
				cvv,
				showConfirm,
				isModalOpen,
				isLoading,
			} = this.state;
			const hasCard = !!cc4;

			let deleteEl = null;
			let warning = null;
			if (!disableDelete) {
				deleteEl = (
					<div className={styles.deleteCard} onClick={this.confirmDelete}>
						Delete
					</div>
				);
			}

			if (warningText) {
				warning = <div className={styles.warning}>{warningText}</div>;
			}

			const month = moment()
				.month(this.props.expMonth - 1)
				.format("MMM");
			let editModal = null;
			let confirmModal = null;

			if (isModalOpen) {
				const errorEl = (
					<div
						className={
							this.state.errorMessage ? styles.error : styles.errorHidden
						}
					>
						{this.state.errorMessage}
					</div>
				);
				const currCard = hasCard ? (
					<div className={styles.currentCard}>
						<div className={styles.item}>{_.repeat("XXXX ", 3) + cc4}</div>
						<div className={styles.item}>
							{"Expires: " + month + " " + this.props.expYear}
						</div>
						{deleteEl}
					</div>
				) : (
					<div className={styles.currentCard}>
						<div className={styles.item}>{"No card on file."}</div>
					</div>
				);

				let changeButton = (
					<div
						className={styles.button}
						onClick={this.update}
						onKeyPress={this.getKeyHandler(this.update)}
						tabIndex={100}
					>
						{hasCard ? "Replace Card" : "Add card"}
					</div>
				);
				const cancelButton = (
					<div
						className={styles.button}
						onClick={this.closeModal}
						onKeyPress={this.getKeyHandler(this.closeModal)}
						tabIndex={101}
					>
						Cancel
					</div>
				);
				if (isLoading) {
					changeButton = (
						<div className={styles.loadingContainer}>
							<div className={styles.loading}>
								<LoadingCircle colorType="white" />
							</div>
						</div>
					);
				}

				editModal = (
					<OfficeModal
						onClose={this.closeModal}
						closeOnEsc={true}
						portalContainer={PORTAL_CONTAINERS.EDITABLE_MODAL}
						level="overBar"
						modalClass={styles.creditModal}
						isScrollable={true}
						scrollTopOnOpen={true}
					>
						<div className={styles.title}>{"Change Payment Method"}</div>
						{warning}
						<div className={styles.label}>{"Current Card"}</div>
						{currCard}
						<div className={styles.label}>
							{hasCard ? "New Card" : "Add Card"}
						</div>
						<div className={styles.newCard}>
							<div className={styles.item}>
								<CreditInfo
									values={{number, expMonth, expYear, cvv}}
									updateField={this.updateField}
									numOptionsShown={3}
									errorFields={this.state.validation}
									initialTabIndex={1}
								/>
							</div>
						</div>
						{errorEl}
						<div className={styles.buttonRow}>
							{changeButton}
							{cancelButton}
						</div>
					</OfficeModal>
				);
			}

			if (showConfirm) {
				confirmModal = (
					<ChooseOptionModal
						portalContainer={PORTAL_CONTAINERS.EDITABLE_MODAL_CONFIRM}
						message={CopyTable.getDeleteCardConfirm()}
						buttonTexts={["delete card", "cancel"]}
						buttonClickHandlers={[this.deleteCard, this.closeConfirm]}
						onClose={this.closeConfirm}
						levelType="warning"
					/>
				);
			}

			const cardInfo = hasCard ? (
				[
					<div className={styles.credit} key={"CC1"}>
						{"Card ending in " + cc4}
					</div>,
					<div className={styles.credit} key={"CC2"}>
						{"Expires: " + month + " " + this.props.expYear}
					</div>,
				]
			) : (
				<div className={styles.credit}>{"No card on file."}</div>
			);

			return (
				<div className={styles.main}>
					<div className={styles.column}>
						{cardInfo}
						<div className={styles.change} onClick={this.openModal}>
							{hasCard ? "Change payment Method" : "Add card"}
						</div>
					</div>
					{editModal}
					{confirmModal}
				</div>
			);
		},
	})
);
